// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { informationStyles } from "@conklin/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

const invoiceInformationPadding = css`
    padding: 0 22px 20px 0;
`;

informationStyles.informationGridContainer = {
    gap: 0,
    css: css`
        padding-bottom: 4px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 24px;
    `,
};

informationStyles.invoiceInformationGridContainer = {
    gap: 0,
    css: css`
        padding-bottom: 24px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 26px;
    `,
};

informationStyles.headingAndTextStyles = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

informationStyles.statusGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.invoiceDateGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.termsGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.poNumberGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.salespersonGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.shippingMethodGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.dueDateGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.vatNumberGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.invoiceNumberGridItem = {
    width: [6, 6, 6, 4, 4],
    css: invoiceInformationPadding,
};
informationStyles.billingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        order: 1;
    `,
};
informationStyles.shippingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        order: 2;
        ${xScreen("lte", "md")} {
            order: 4;
        }
    `,
};

informationStyles.billingAddressStyle = {
    titleText: {
        ...mergeWithCss(xOrderInformationStyles.address?.informationTitle, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
    headerText: {
        css: css`
            display: none;
        `,
    },
};
informationStyles.shippingAddressStyle = {
    wrapper: {
        css: css`
            ${xScreen("lte", "md")} {
                margin-bottom: 0;
            }
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    headerText: {
        ...mergeWithCss(xOrderInformationStyles.address?.informationTitle, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
};

informationStyles.addressesTitle = {
    ...xOrderInformationStyles.address?.heading,
};

informationStyles.addressesGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
        padding-top: 0;
        padding-bottom: 0;
    `,
};

informationStyles.invoiceNotesGridItem = {
    width: 12,
    css: css`
        padding-top: 24px;
        order: 3;
        ${xScreen("lte", "md")} {
            padding-bottom: 24px;
        }
    `,
};
